import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class JdsCustomColorPicker extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closestSection = this.closest('.shopify-section, dialog');
    this.closestSection?.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
    this.bindInputs();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  handleVariantUpdate = (event) => {
    const updated = event.detail?.data?.html?.querySelector('product-custom-color-picker');
    if (!updated) return;
    morph(this, updated, { childrenOnly: true });
    this.bindInputs();
  };

  bindInputs() {
    const swatch = this.querySelector('.jds-ccp__swatch');
    const hex = this.querySelector('.jds-ccp__hex');
    if (!swatch || !hex || swatch.dataset.jdsBound) return;
    swatch.dataset.jdsBound = '1';

    swatch.addEventListener('input', () => {
      hex.value = swatch.value.toUpperCase();
    });

    hex.addEventListener('input', () => {
      let value = hex.value.trim();
      if (value && !value.startsWith('#')) value = '#' + value;
      if (/^#[0-9A-Fa-f]{6}$/.test(value)) swatch.value = value;
    });
  }
}

if (!customElements.get('product-custom-color-picker')) {
  customElements.define('product-custom-color-picker', JdsCustomColorPicker);
}
